import { render, staticRenderFns } from "./dangerousCollect.vue?vue&type=template&id=44c6e416&scoped=true"
import script from "./dangerousCollect.vue?vue&type=script&lang=js"
export * from "./dangerousCollect.vue?vue&type=script&lang=js"
import style0 from "./dangerousCollect.vue?vue&type=style&index=0&id=44c6e416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c6e416",
  null
  
)

export default component.exports